// extracted by mini-css-extract-plugin
export default {"profile-image":"Profile_profile-image__HZ-hR","activateButton":"Profile_activateButton__w+qUx","name-text":"Profile_name-text__j58Gl","email-text":"Profile_email-text__Xjpha"};